module.exports = __webpack_public_path__ + "img/picture_kqtj.d395e9f4.png";